var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExemptionNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1815 19.5453C17.1815 17.7129 16.4535 15.9556 15.1578 14.6599C13.8621 13.3642 12.1048 12.6362 10.2724 12.6362C8.43997 12.6362 6.68261 13.3642 5.38691 14.6599C4.0912 15.9556 3.36328 17.7129 3.36328 19.5453",
    stroke: "#26262A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2713 12.6364C12.6562 12.6364 14.5895 10.703 14.5895 8.31818C14.5895 5.93332 12.6562 4 10.2713 4C7.88644 4 5.95312 5.93332 5.95312 8.31818C5.95312 10.703 7.88644 12.6364 10.2713 12.6364Z",
    stroke: "#26262A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6362 18.6818C20.6362 15.7713 18.9089 13.0681 17.1816 11.7727C17.7494 11.3467 18.2034 10.7873 18.5035 10.1441C18.8035 9.50084 18.9404 8.79353 18.902 8.08477C18.8636 7.37602 18.651 6.68766 18.2832 6.08062C17.9153 5.47358 17.4035 4.96658 16.793 4.60449",
    stroke: "#26262A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExemptionNew);
export default __webpack_public_path__ + "static/media/exemption_new.614df0bc50da75ab82affca55c3103a9.svg";
export { ForwardRef as ReactComponent };